import { userConstants } from '../constants';

export const userReducer = (state = {}, action) => {
    // delete password for security
    if(action && action.payload && action.payload.hasOwnProperty('password')) delete action.payload.password;

    switch(action.type) {
        case userConstants.GET_USER_DATA_REQEUST:
            return {
                ...state,
                getDataProcess: true
            }

        case userConstants.GET_USER_DATA_SUCCESS: 
            return {
                ...state,
                data: Object.assign(state.data || {}, action.payload),
                getDataProcess: false,  
                getDataError: false
            }

        case userConstants.GET_USER_DATA_FAILURE: 
            return {
                ...state,
                getDataProcess: false,
                getDataError: true
            }

        case userConstants.UPDATE_USER_DATA_REQUEST:
            return {
                ...state,
                updateDataProcess: true
            }

        case userConstants.UPDATE_USER_DATA_SUCCESS: 
            return {
                ...state,
                data: Object.assign(state.data || {}, action.payload),
                updateDataProcess: false,  
                updateDataError: false
            }

        case userConstants.UPDATE_USER_DATA_FAILURE: 
            return {
                ...state,
                updateDataProcess: false,  
                updateDataError: true
            }

        case userConstants.UPLOAD_USER_LOGO_FAILURE:
            return {
                ...state,
                uploadLogoProcess: false,
                uploadLogoError: true
            }

        case userConstants.UPLOAD_USER_LOGO_REQUEST:
            return {
                ...state,
                uploadLogoProcess: true
            }
            
        case userConstants.UPLOAD_USER_LOGO_SUCCESS:
            return {
                ...state,
                data: {...state.data, logo: action.payload},
                uploadLogoProcess: false,
                uploadLogoError: false,
            }

        case userConstants.DELETE_USER_LOGO_FAILURE:
            return {
                ...state,
                deleteLogoProcess: false,
                deleteLogoError: true
            }

        case userConstants.DELETE_USER_LOGO_REQUEST:
            return {
                ...state,
                deleteLogoProcess: true
            }
            
        case userConstants.DELETE_USER_LOGO_SUCCESS:
            const { data: { logo, ...data } } = state; // delete logo es6 (immutable)
            return {
                ...state,
                data: data,
                deleteLogoProcess: false,
                deleteLogoError: false
            }

        default: 
            return state;
    }
}

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/user.js